import React from 'react';
import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

export default function UiChip({ label, onClick, onDelete, ...otherProps }) {
  return (
    <Chip label={label} onClick={onClick} onDelete={onDelete} {...otherProps} />
  );
}

UiChip.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
};
